<template>
    <div>    
        <div v-if="passedData">
            {{$t('REGISTRATION.USERS.parentId')}}: {{passedData.parentId}}
        </div>
        <div class="form-group">
            <label for="role" class="input-label">
                {{$t('REGISTRATION.USERS.chooseRole')}}
            </label>
            <select class="custom-select form-control-sm"
                    id="role"
                    v-model="roleChosen">
                <option :value="role" :key="index"
                        v-for="(role, index) in limitedRoles">
                    {{role.displayName}}
                </option>
            </select>
        </div>
        <register-form :role="roleChosen"
                       :editForm="passedData"
                       @save="handleSave"
                       @cancel="changeTab"
        ></register-form>
    </div>
</template>

<script type="text/babel">
import { mapActions, mapMutations, mapGetters } from 'vuex';
import RegisterForm from './RoleSpecificForms/RegisterForm'; 
import { RegistrationPerimeter } from '../../../../router/perimeters/registrationPerimeter';
import {EventBus} from '@/eventbus';

export default {
    name: 'FormContainer',
    data () {
        return {
            editMode: false,
            roleChosen: {},
            roles: [
                {
                    name: this.$TYPES.ROLES.ADMIN,
                    displayName: this.$t('REGISTRATION.USERS.ROLES.admin')
                },
                {
                    name: this.$TYPES.ROLES.KEY_ACCOUNT,
                    displayName: this.$t('REGISTRATION.USERS.ROLES.keyAccount')
                },
                {
                    name: this.$TYPES.ROLES.SHOP_OWNER,
                    displayName: this.$t('REGISTRATION.USERS.ROLES.shopOwner')
                },
                {
                    name: this.$TYPES.ROLES.OPERATOR,
                    displayName: this.$t('REGISTRATION.USERS.ROLES.operator')
                },
                {
                    name: this.$TYPES.ROLES.PARTNER,
                    displayName: this.$t('REGISTRATION.USERS.ROLES.partner')
                },
                {
                    name: this.$TYPES.ROLES.SALES,
                    displayName: this.$t('REGISTRATION.USERS.ROLES.sales')
                }
            ]
        };
    },
    props: {
        passedData: {
            type: Object
        }
    },
    perimeters: [RegistrationPerimeter],
    components: {
        RegisterForm
    },
    watch: {
        passedData: {
            handler (data) {
                if(data) {
                    this.roleChosen = this.passedData.role;
                    this.editMode = true;
                } else {
                    this.editMode = false;
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters({userId: 'getUserId'}),
        limitedRoles () {
            return this.roles.filter(({name}) => {
                if (this.editMode && this.passedData) {
                    if (this.passedData.parentRole === name) {
                        return true;
                    }
                }
                return this.passedData
                    ? this.$isAllowed('add', name) && this.$isAllowed('roleCanAdd', {
                        parentRole: this.passedData.parentRole,
                        role: name
                    }) : this.$isAllowed('add', name);
            }
            );
        }
    },
    methods: {
        ...mapMutations([
            'updateCompany'
        ]),
        ...mapActions([
            'RegisterUser',
            'PutUser'
        ]),
        async handleSave (form) {
            if(this.$utils.isNil(form)) {
                return;
            }
            if(this.passedData) {
                form.parentId = this.passedData.parentId;
            }
            this.editMode ? await this.PutUser(form) : await this.RegisterUser(form);
            this.changeTab();
            this.$router.push('/');
            EventBus.$emit('updateUserList');
        },
        changeTab () {
            this.$emit('changeTab', {name: 'Users', data: null});
            this.$router.push('/');
        }
    },
    created () {
        if(this.passedData) {
            this.roleChosen = this.passedData.role;
            this.editMode = !this.passedData.parentId;
        } else {
            this.editMode = false;
        }
    }
};
</script>
